<template>
  <div id="footer-div">
    <footer
      class="footer"
      style="background-color: #e4ff26; color: black"
    >
      <div
        class="container d-flex flex-column flex-md-row align-items-center justify-content-between py-3"
      >
        <!-- Left -->
        <div class="mb-2 mb-md-0">© 2026 Copyright</div>

        <!-- Center -->
        <div class="mb-2 mb-md-0">
          <a href="https://www.ptspace.pt" target="_blank">
            <img
              src="../assets/logo_black.png"
              alt="PT Space"
              height="50"
              style="object-fit: contain"
            />
          </a>
        </div>

        <!-- Right -->
        <div>
          <a
            href="https://ptspace.pt/privacy-policy/"
            target="_blank"
            class="footer-link"
            >Privacy Policy</a
          >
        </div>
      </div>
    </footer>
  </div>
  <!-- End of .container -->
</template>
<style>
.footer-link {
  color: black;
  text-decoration: none;
  font-size: 1rem;
}

.footer-link:hover {
  text-decoration: none;
  color: #757d83;
}
.footer {
  backdrop-filter: blur(6px);
}

#footer-div {
  margin-top: auto;
}
</style>
<script>
import { useRoute } from "vue-router";
export default {
  setup() {
    const route = useRoute();
    const routeName = route.path.slice(1);
    return {
      routeName,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>
